<template>
    <div class="container-fluid">
    <div class="row justify-content-center my-4">
        <div class="col-md-6 col-lg-5">
        <div class="form-card">
            <div class="form-card__header">
        <h6 class="form-card__title">
        <i class="bi bi-upload"></i>
        Importar productos desde archivo
        </h6>
    </div>

    <div class="form-card__body">
        <p class="form-card__hint" style="font-size: 13px; margin-bottom: 16px;">
            Para proceder con la importación masiva de productos, lo primero que debemos hacer es bajar el archivo de ejemplo. Luego lo abriremos en un editor de hojas de cálculo e ingresaremos todos los productos en el orden correcto. Para finalizar, subí el archivo al sistema y la importación será inmediata.
        </p>
        <div class="form-card__field">
        <a href="#" class="form-card__btn" @click.prevent="downloadTemplate">
          <i class="bi bi-download"></i>
          Bajar archivo Guía de Productos
        </a>
      </div>
        <div class="form-card__field">
        <label class="form-card__label" for="import-file">Archivo de productos</label>
        <input
            id="import-file"
            ref="fileInput"
            type="file"
            class="form-control"
            accept=".csv,.xls,.xlsx"
            @change="selectedFile"
        >
        <div v-if="file" class="form-card__hint">{{ file.name }}</div>
        <div v-else class="form-card__hint">Seleccione un archivo .csv, .xls o .xlsx</div>
        </div>
    </div>

    <div class="form-card__footer">
        <button
        type="button"
        class="form-card__btn form-card__btn--primary"
        :disabled="!file || loading"
        @click="subir"
        >
        <i class="bi bi-cloud-upload"></i>
        {{ loading ? 'Subiendo...' : 'Importar archivo' }}
        </button>
    </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        file: null,
        loading: false,
        };
    },
    methods: {
        selectedFile(event) {
        this.file = event.target.files[0] || null;
        },
        resetFile() {
        this.file = null;
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
        }
        },
        subir() {
        if (!this.file) return;
        this.loading = true;
        const formData = new FormData();
        formData.append('productfile', this.file);
        this.$http
            .post('/api/products/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((response) => {
            const status = response && response.status;
            if (status && status >= 200 && status < 300) {
                this.resetFile();
            }
            })
            .catch(() => {
            this.$store.commit(
                'errors/pushMsg',
                'No se pudo importar el archivo. Verifique el formato y volvé a intentarlo.',
            );
            })
            .finally(() => {
            this.loading = false;
            });
        },
    },
};
</script>
